module.exports = __webpack_public_path__ + "static/enter-name-e6bf3e9b5b7e63b50f4e3b3ba81877a5.gif";